<add-user-form
    *ngIf="dashboards$ | async"
    [organisation]="organisation$ | async"
    [dashboards]="dashboards$ | async"
    (submit)="handleSubmit($event)"
>
</add-user-form>
